import * as React from 'react';
import cn from 'clsx';

import { useApplicationContext } from '../../utils/applicationContext';

import * as styles from './styles.css';

export interface IPageBaseLayout {
  quizCompleted?: boolean;
}

export const PageBaseLayout: React.FC<React.PropsWithChildren<IPageBaseLayout>> = props => {
  const applicationContext = useApplicationContext();
  const updateApplicationEnabled = applicationContext.config.get<boolean>('demand.ApplicationFormV5.Enabled') || false;

  return (
    <div
      className={cn(
        styles['wrapper'],
        updateApplicationEnabled && styles['new-wrapper-theme'],
        props.quizCompleted && styles['quiz_completed'],
      )}
    >
      <div className={styles['container']}>{props.children}</div>
    </div>
  );
};

PageBaseLayout.displayName = 'PageBaseLayout';
